import React, { useCallback, useEffect, useState } from 'react';
import { createTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { isUndefined, isNull, isEmpty } from 'lodash';

import { uploadContentService } from '../../../services';

import {
  Button,
  Grid,
  makeStyles,
} from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const defaultTheme = createTheme();

const useStyles = makeStyles((theme) => ({
  cardElement: {
    width: '100%',
    height: '500px',
    border: '1px solid gray'
  },
  dialogModalContent: {
    padding: '24px',
    width: '600px'
  },
  radioIcon: {
    fontSize: '50px',
    marginRight: '5px'
  },
  unitDetails:{
    display: 'grid'
  },
  unitContainer: {
    display: 'flex'
  },
  gridContainerElement: {
    padding: '10px 0px',
    height: '100%'
  },
  gridItem: {
    display: 'flex',
    width: '100%',
    marginBottom: 20
  },
  columnItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  innerGridContainerElement: {
    width: '100%',
    padding: '24px',
    height: '300px',
    overflow: 'auto'
  },
  multilineTextArea: {
    width: '100%'
  },
  titlePanelText: {
    fontWeight: 'bold'
  },
  downloadProgressList: {
    height: '300px',
    overflow: 'auto'
  },
  columnItemDownloadsLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '80%',
    padding: '20px 10px 10px 20px'
  },
  columnItemDownloadsRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '20%',
    padding: '20px 10px 10px 10px'
  },
  flexItemContainer: {
    display: 'flex'
  },
  gridItemDownloads: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 20
  },
  downloadProgressBar: {
    padding: '0px 20px'
  },
  downloadName: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    height: '21px'
  },
  unitErrorLogList: {
    height: '300px',
    overflow: 'auto'
  },
  snapshotImage: {
    width: '90%',
    height: '100%'
  },
  columnSnapshotItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100px'
  },
  gridItemErrorLogs: {
    display: 'flex',
    width: '100%',
    marginBottom: 10,
    height: '120px',
    borderBottom: '1px solid gray'
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <span>{children}</span>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AlertDialogSlide({ modalShow, modalState, unitId }) {
  const classes = useStyles();
  const [open, setOpen] = useState(modalShow);
  const [expandItemNumber, setExpandItemNumber] = useState(null);
  const [unitPropertyDetails, setUnitPropertyDetails] = useState({});
  const [unitPropertyDownloads, setUnitPropertyDownloads] = useState({});
  const [unitPropertyErrorLogs, setUnitPropertyErrorLogs] = useState({});
  const [unitPropertySnapshots, setUnitPropertySnapshots] = useState({});
  const [openGroup, setOpenGroup] = useState(false);
  const [row, setRow] = useState([]);

  const [value, setValue] = useState(0);

  const { user } = useSelector(state => state.userAuthentication);

  const handleCollapseClick = (event) => {
    const index = event.currentTarget.dataset.index;

    if (index) {
      setExpandItemNumber(parseInt(index));
      setOpenGroup(!openGroup);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    modalState(false);
    // setOpen(false);
  };

  const [editRowsModel, setEditRowsModel] = useState({});

  const handleEditRowsModelChange = useCallback((model) => {
    setEditRowsModel(model);
  }, []);

  const getUnitPropertyDetails = useCallback(async () => {
    if (!isUndefined(user) && !isUndefined(unitId)) {
      const res = await uploadContentService.unitPropertyDetails(user, unitId);
  
      if (!isUndefined(res)) {
        setUnitPropertyDetails(res);
      }
    }
  }, [user]);
  
  useEffect(() => {
    getUnitPropertyDetails();
  }, [getUnitPropertyDetails]);

  const getUnitPropertyDownloads = useCallback(async () => {
    if (!isUndefined(user) && !isUndefined(unitId)) {
      const res = await uploadContentService.unitPropertyDownloads(user, unitId);
  
      if (!isUndefined(res)) {
        setUnitPropertyDownloads(res);
      }
    }
  }, [user]);
  
  useEffect(() => {
    getUnitPropertyDownloads();
  }, [getUnitPropertyDownloads]);

  const getUnitPropertyErrorLogs = useCallback(async () => {
    if (!isUndefined(user) && !isUndefined(unitId)) {
      const res = await uploadContentService.unitPropertyErrorLogs(user, unitId);
  
      if (!isUndefined(res)) {
        setUnitPropertyErrorLogs(res);
      }
    }
  }, [user]);
  
  useEffect(() => {
    getUnitPropertyErrorLogs();
  }, [getUnitPropertyErrorLogs]);

  const getUnitPropertySnapshots = useCallback(async () => {
    if (!isUndefined(user) && !isUndefined(unitId)) {
      const res = await uploadContentService.unitPropertySnapshots(user, unitId);
  
      if (!isUndefined(res)) {
        setUnitPropertySnapshots(res);
      }
    }
  }, [user]);
  
  useEffect(() => {
    getUnitPropertySnapshots();
  }, [getUnitPropertySnapshots]);

  const GridRow = () => {
    return (
      <>
        {!isUndefined(unitPropertyDetails?.devices) && !isNull(unitPropertyDetails?.devices) ? (
          <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid className={classes.gridItem} item xs={12}>
                <div className={classes.columnItem}>
                  <span>Unit ID: </span>
                  <span>Unit Name: </span>
                  <span>Model: </span>
                </div>
                <div className={classes.columnItem}>
                  <span>{unitPropertyDetails.devices.serial}</span>
                  <span>{unitPropertyDetails.devices.name}</span>
                  <span>{unitPropertyDetails.devices.model}</span>
                </div>
              </Grid>
              <Grid className={classes.gridItem} item xs={12}>
                <div className={classes.columnItem}>
                  <span>Target Group: </span>
                  <span>Target Time Zone: </span>
                  <span>Reported Group: </span>
                  <span>Reported Time Zone: </span>
                </div>
                <div className={classes.columnItem}>
                  <span>{unitPropertyDetails.devices.targetGroup?.name}</span>
                  <span>{unitPropertyDetails.devices.targetTimeZone}</span>
                  <span>{unitPropertyDetails.devices.reportedGroup?.name}</span>
                  <span>{unitPropertyDetails.devices.reportedTimeZone}</span>
                </div>
              </Grid>
              <Grid className={classes.gridItem} item xs={12}>
                <div className={classes.columnItem}>
                  <span>Firmware: </span>
                  <span>Autorun version: </span>
                  <span>Remote Snapshot: </span>
                </div>
                <div className={classes.columnItem}>
                  <span>{unitPropertyDetails.devices.firmwareVersion}</span>
                  <span>{unitPropertyDetails.devices.autorun?.version}</span>
                  <span>{unitPropertyDetails.devices.remoteSnapshotSettings?.enabled ? 'Enabled' : 'Not Enabled'}</span>
                </div>
              </Grid>
              <Grid className={classes.gridItem} item xs={12}>
                <div className={classes.columnItem}>
                  <span>IP Address: </span>
                  <span>Card Size: </span>
                  <span>Card Realized Size: </span>
                </div>
                <div className={classes.columnItem}>
                  <span>{unitPropertyDetails.devices.networkSettings?.wireless?.ipAddress ? unitPropertyDetails.devices.networkSettings?.wireless?.ipAddress : 'None'}</span>
                  <span>{unitPropertyDetails.devices.cardSize}</span>
                  <span>{unitPropertyDetails.devices.cardFreeSize}</span>
                </div>
              </Grid>
              <Grid className={classes.gridItem} item xs={12}>
                <div className={classes.columnItem}>
                  <span>Subscription Type: </span>
                  <span>Subscription Status: </span>
                </div>
                <div className={classes.columnItem}>
                  <span>{unitPropertyDetails.devices.currentSubscription?.type}; {unitPropertyDetails.devices.currentSubscription?.activityPeriod}</span>
                  <span>{unitPropertyDetails.devices.currentSubscription?.status}</span>
                </div>
              </Grid>
            </Grid>
          </>
        ) : ''}
      </>
    )
  }

  const GridRowErrorLogs = () => {
    const errorLogs = unitPropertyErrorLogs?.errors?.items;

    return (
      <>
        {!isUndefined(errorLogs) && !isNull(errorLogs) ? (
          <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              {[...errorLogs].map(item => (
                <>
                  <Grid className={classes.gridItemErrorLogs} item xs={12}>
                    <div className={classes.columnItem}>
                      <span>Timestamp: </span>
                      <span>Reason: </span>
                    </div>
                    <div className={classes.columnItem}>
                      <span>{new Date(item.timestamp).toDateString()}</span>
                      <span style={{ textOverflow: 'ellipsis', height: '85px', overflow: 'hidden' }}>{item.reason ? item.reason : 'None'}</span>
                    </div>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        ) : ''}
      </>
    )
  }

  const GridRowSnapshots = () => {
    const snapshots = unitPropertySnapshots?.screenshots?.items;

    return (
      <>
        {!isUndefined(snapshots) && !isNull(snapshots) ? (
          <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              {[...snapshots].map(item => (
                <>
                  <Grid className={classes.gridItem} item xs={12}>
                    <div className={classes.columnSnapshotItem}>
                      <img className={classes.snapshotImage} src={item.filePath} alt="screenshot" />
                    </div>
                    <div className={classes.columnSnapshotItem}>
                      <span>{item.localTimestamp}</span>
                      <span>{item.groupName}</span>
                      <span>MasterList</span>
                      <span>Size: {item.width}x{item.height}</span>
                    </div>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        ) : ''}
      </>
    )
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
  }));

  const DownloadRow = (downloads) => {
    const downloadsList = downloads?.downloads?.downloads?.items;

    return (
      <>
        {!isUndefined(downloadsList) && !isNull(downloadsList) && !isEmpty(downloadsList) ? (
          <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              {[...downloadsList].map(item => (
                <>
                  <Grid className={classes.gridItemDownloads} item xs={12}>
                    <div className={classes.flexItemContainer}>
                      <div className={classes.columnItemDownloadsLeft}>
                        {/* <span>Missy Elliot - Work It [Official Music Video].mp4</span> */}
                        <span className={classes.downloadName}>{item.fileName}</span>
                      </div>
                      <div className={classes.columnItemDownloadsRight}>
                        {/* <span>50%</span> */}
                        <span>{item.progress}</span>
                      </div>
                    </div>
                    <div className={classes.downloadProgressBar}>
                      <BorderLinearProgress variant="determinate" value={item.progress} />
                    </div>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        ) : ''}
      </>
    )
  }

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}></Button>
      <Dialog
        disableBackdropClick={true}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle className="dialog-modal-title" id="alert-dialog-slide-title">
          {!isUndefined(unitPropertyDetails?.devices) && !isNull(unitPropertyDetails?.devices) ? (
            `Device "${unitPropertyDetails?.devices.name}" Properties`
          ) : '...'}
        </DialogTitle>
        <DialogContent className={classes.dialogModalContent}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="General" {...a11yProps(0)} />
                <Tab label="Errors" {...a11yProps(1)} />
                <Tab label="Downloads" {...a11yProps(2)} />
                <Tab label="Snapshots" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <div>
                {openGroup && expandItemNumber === 0 ? <ExpandLess data-value={0} data-index={0} onClick={handleCollapseClick} className={classes.expandIcons} style={{ cursor: "pointer" }} /> : <ExpandMore data-value={0} data-index={0} onClick={handleCollapseClick} className={classes.expandIcons} style={{ cursor: "pointer" }} />}
                Device Overview
              </div>
              <Collapse in={expandItemNumber === 0 ? openGroup : false} timeout="auto" unmountOnExit>
                <Grid className={classes.gridContainerElement} container spacing={1}>
                  <Grid className={classes.innerGridContainerElement} container spacing={3}>
                    <GridRow />
                  </Grid>
                </Grid>
              </Collapse>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <p className={classes.titlePanelText}>Device Error Logs</p>
              <Grid className={classes.unitErrorLogList} container spacing={1}>
                <Grid className={classes.innerGridContainerElement} container spacing={3}>
                  <GridRowErrorLogs />
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={2}>
              {!isUndefined(unitPropertyDownloads) && !isNull(unitPropertyDownloads) ? (
                <>
                  {/* <Grid className={classes.gridItem} item xs={12}>
                    <div className={classes.columnItem}>
                      <p>Download began at: </p>
                      <p>Download completed at: </p>
                    </div>
                    <div className={classes.columnItem}>
                      <p>20 Sep 2021 06:48:19 UTC</p>
                      <p>20 Sep 2021 06:48:20 UTC</p>
                    </div>
                  </Grid> */}
                  <p className={classes.titlePanelText}>Download Progress</p>
                  <Grid className={classes.downloadProgressList} container spacing={1}>
                    <Grid container item xs={12} spacing={3}>
                      <DownloadRow downloads={unitPropertyDownloads} />
                    </Grid>
                  </Grid>
                </>
              ) : ''}
            </TabPanel>
            <TabPanel value={value} index={3}>
              <p className={classes.titlePanelText}>Settings</p>
              <Grid className={classes.unitErrorLogList} container spacing={1}>
                <Grid className={classes.innerGridContainerElement} container spacing={3}>
                  <GridRowSnapshots />
                </Grid>
              </Grid>
            </TabPanel>
          </Box>
        </DialogContent>
        <DialogActions className="dialog-modal-action">
          <div>
            <Button variant="contained" color="default" onClick={handleClose} >
              Close
            </Button>
            <Button className="color-changer" variant="contained" style={{ marginLeft: '10px' }} onClick={handleClose} >
              Add
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}